import React, { useState } from "react";
import { DataGrid } from "@material-ui/data-grid";
import {
  Button,
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import {
  contratacionesCartillaPrestadoresDelete,
  contratacionesCartillaPrestadoresSave,
} from "../../../actions/contrataciones/contratacionesCartilla";
import DeleteForever from '@material-ui/icons/DeleteForever';
import EditIcon from "@material-ui/icons/Edit";
import { CartillaForm } from "./CartillaForm";
import moment from 'moment'

const RenderEditButton = (cellValue) => {
  const dispatch = useDispatch();
  const [openEdit, setOpenEdit] = useState(false)

  return (
    <strong>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ marginLeft: 16 }}
        onClick={() => {
          setOpenEdit(true)
        }}
      >
        <EditIcon />
      </Button>

      {
        openEdit && (
          <Dialog
            open={openEdit}
            onClose={(e) => setOpenEdit(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            fullWidth
            maxWidth="md"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Guardar Prestador"}
            </DialogTitle>
            <DialogContent>
              <CartillaForm formData={cellValue.row} handleSubmit={(data) => {
                dispatch(contratacionesCartillaPrestadoresSave(data)).then((e) => {
                  setOpenEdit(false)
                }).catch((e) => {})
              }}
                handleCloseModal={() => setOpenEdit(false)}
              />
            </DialogContent>
          </Dialog>
        )
      }
    </strong>
  );
};

const RenderDeleteButton = (cellValue) => {
  const dispatch = useDispatch();
  const [openDelete, setOpenDelete] = useState(false)
  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        size="small"
        style={{ marginLeft: 16 }}
        onClick={(e) => {
          setOpenDelete(true)
        }}
      >
        <DeleteForever />
      </Button>
      {
        openDelete && (
          <Dialog
            open={openDelete}
            onClose={(e) => setOpenDelete(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Eliminar Cartilla"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                ¿Desea eliminar este item de cartilla de forma permanente?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  dispatch(
                    contratacionesCartillaPrestadoresDelete(
                      cellValue.row.id
                    )
                  );
                  setOpenDelete(false);
                }}
                color="primary"
              >
                Aceptar
              </Button>
              <Button
                onClick={(e) => {
                  setOpenDelete(false);
                }}
                color="primary"
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>
        )
      }
    </>
  );
};

let columns = (dataContrato, disabled) => [
  { field: "domicilio", headerName: "Domicilio", width: 200 },

  { field: "telefono", headerName: "Telefono", width: 200, },
  { field: "cp", headerName: "CP", width: 80, },
  { field: "localidad", headerName: "Localidad", width: 200 },
  { field: "provincia", headerName: "Provincia", width: 200 },
  { field: "zona", headerName: "Zona", width: 200 },
  { field: "cartilla", headerName: "Cartilla", width: 110 },
  { field: "centroMedico", headerName: "Centro Medico", width: 350 },
  { field: "especialidades", headerName: "Especialidades", width: 500 },
  { field: "planes", headerName: "Planes", width: 320 },
  { field: "rubro", headerName: "Rubro", width: 415 },
  { field: "ranking", headerName: "Ranking | Cartilla", width: 250 },
  {
    field: "publica",
    headerName: "¿Publica en cartilla?",
    width: 250,
    renderCell: (cellValue) => <p>{cellValue.row.publica ? "Sí" : "No"}</p>
  },
  {
    field: "atiendeCentroPropio",
    headerName: "¿Atiende en centro medico propio?",
    width: 250,
    renderCell: (cellValue) => <p>{cellValue.row.atiendeCentroPropio ? "Sí" : "No"}</p>
  },
  {
    field: "fechaBaja",
    headerName: "Fecha de Baja",
    width: 150,
    renderCell: (cellValue)=>cellValue.row.fechaBaja !== null && moment(cellValue.row.fechaBaja).format('DD/MM/YYYY'),
    disableClickEventBubbling: true,
  },
  {
    field: "colEditButton",
    headerName: "Editar",
    width: 158,
    renderCell: RenderEditButton,
    disableClickEventBubbling: true,
    hide: disabled
  },
  {
    field: "colDeleteButton",
    headerName: "Eliminar",
    width: 173,
    renderCell: RenderDeleteButton,
    disableClickEventBubbling: true,
    hide: disabled
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "4px",
    backgroundColor: theme.palette.background.paper,
    height: "85vh",
    width: "100%",
  },
}));

export const CartillaTable = (props) => {
  const classes = useStyles();

  const { cartillaPrestadores, disabled } = props
  const { items: localidades } = useSelector((state) => state.localidades);
  const { items: provincias } = useSelector((state) => state.provincias);
  const {
    rubros,
    zonas,
    centrosMedicos,
    rankingsCartilla,
    cartilla,
    planes,
  } = useSelector((state) => state.contratacionesCartilla);
  const { dataContrato } = useSelector((state) => state.contrataciones);
  const { items: especialidades } = useSelector((state) => state.especialidades);

  const options = {
    responsive: "scroll",
  };

  const cartillaPrestadoresFormateados = cartillaPrestadores.map(
    (cartillaPrestador, index) => {

      const especialidadesFormateadas = [];
      cartillaPrestador.cartillaPrestadoresEspecialidades.forEach(
        (idEspecialidad) => {
          especialidadesFormateadas.push(
            especialidades.find(
              (especialidad) => especialidad.idEspecialidades === idEspecialidad
            )
          );
        }
      );

      const planesFormateadas = [];
      cartillaPrestador.cartillaPrestadoresPlanesContratos.forEach((idPlan) => {
        planesFormateadas.push(planes.find((plan) => plan.id === idPlan));
      });

      const datosDomicilio = {};

      if (cartillaPrestador.atiendeCentroPropio) {
        const centroMedico = centrosMedicos.find(
          (centroMedico) =>
            centroMedico.idCentroMedico === parseInt(cartillaPrestador.idCentroMedico)
        );

        let localidadEncontrada = localidades.find((loc) =>
          parseInt(loc?.id_localidad) === parseInt(centroMedico?.idLocalidad)
        );
        let provinciaEncontrada = provincias.find((prov) =>
          parseInt(prov?.id_provincia) === parseInt(localidadEncontrada?.id_provincia)
        );

        let zonaEncontrada = zonas.find(
          (zona) =>
            parseInt(zona.idProvincia) ===
            parseInt(localidadEncontrada?.id_provincia)
        );
        datosDomicilio.domicilio = centroMedico?.direccion;
        datosDomicilio.cp = centroMedico?.cp;
        datosDomicilio.telefono = centroMedico?.telefono;
        datosDomicilio.localidad = localidadEncontrada?.descripcion_localidad;
        datosDomicilio.idLocalidad = localidadEncontrada.id_localidad
        datosDomicilio.provincia = provinciaEncontrada?.descripcion_provincia;
        datosDomicilio.idProvincia = provinciaEncontrada.id_provincia
        datosDomicilio.zona = zonaEncontrada?.descripcion;
        datosDomicilio.idZona = zonaEncontrada?.idZona
        datosDomicilio.cartilla = cartilla.find((cartilla) => cartilla.idCartilla === zonaEncontrada?.idCartilla)?.descripcionCartilla
        datosDomicilio.idCartilla = zonaEncontrada?.idCartilla
      } else {
        let localidadEncontrada = localidades.find((loc) =>
          parseInt(loc?.id_localidad) === parseInt(cartillaPrestador.cartillaPrestadoresDomicilio?.idLocalidad)
        );

        let provinciaEncontrada = provincias.find((prov) =>
          parseInt(prov?.id_provincia) === parseInt(localidadEncontrada?.id_provincia)
        );

        let zonaEncontrada = zonas.find(
          (zona) =>
            parseInt(zona.idProvincia) ===
            parseInt(localidadEncontrada?.id_provincia)
        );

        datosDomicilio.domicilio = cartillaPrestador.cartillaPrestadoresDomicilio?.domicilio;
        datosDomicilio.cp = cartillaPrestador.cartillaPrestadoresDomicilio?.cp;
        datosDomicilio.telefono = cartillaPrestador.cartillaPrestadoresDomicilio?.telefono;
        datosDomicilio.localidad = localidadEncontrada?.descripcion_localidad;
        datosDomicilio.provincia = provinciaEncontrada?.descripcion_provincia;
        datosDomicilio.zona = zonaEncontrada?.descripcion;
        datosDomicilio.cartilla = cartilla.find((cartilla) => cartilla.idCartilla === zonaEncontrada?.idCartilla)?.descripcionCartilla
      }

      return {
        ...cartillaPrestador,
        ...datosDomicilio,
        cartillaPrestadoresDomicilio: cartillaPrestador.atiendeCentroPropio ? {...datosDomicilio} : {...cartillaPrestador.cartillaPrestadoresDomicilio }  ,
        id: cartillaPrestador.idCartillaPrestadores,
        atiendeCentroPropio: cartillaPrestador.atiendeCentroPropio,
        centroMedico: centrosMedicos.find(
          (centroMedico) =>
            centroMedico.idCentroMedico ===
            parseInt(cartillaPrestador.idCentroMedico)
        )?.descripcionCentro,
        especialidades: especialidadesFormateadas
          ?.map((especialidad) => especialidad?.descripcionEspecialidades)
          .join(", "),
        planes: planesFormateadas?.map((plan) => plan?.descripcion).join(", "),
        rubro: rubros.find(
          (rubro) => rubro.idRubro === parseInt(cartillaPrestador.idRubro)
        )?.descripcion,
        ranking: rankingsCartilla.find(
          (ranking) =>
            ranking.idRankingCartilla === parseInt(cartillaPrestador.idRanking)
        )?.descripcion
      };
    }
  );

  return (
    <React.Fragment>
      <div className={classes.root}>
        <DataGrid
          rows={cartillaPrestadoresFormateados}
          rowHeight={40}
          columns={columns(dataContrato, disabled)}
          setRowProps={options}
          columnBuffer={12}
          pageSize={15}
          showToolbar
          rowsPerPageOptions={[15, 20]}
          density="comfortable"
          localeText={{
            noRowsLabel: "No hay Prestadores",
            toolbarDensity: "Tamaño",
            toolbarDensityLabel: "Tamaño",
            toolbarDensityCompact: "Chico",
            toolbarDensityStandard: "Mediano",
            toolbarDensityComfortable: "Grande",
            toolbarColumns: "Columnas",
            toolbarColumnsLabel: "Selección de Columnas",
            toolbarFilters: "Filtros",
            toolbarFiltersLabel: "Mostrar Filtros",
            toolbarFiltersTooltipHide: "Ocultar Filtros",
            toolbarFiltersTooltipShow: "Mostrar Filtros",
            toolbarFiltersTooltipActive: (count) => `${count} Filtros Activos`,
            // Columns panel text
            columnsPanelTextFieldLabel: "Buscar columna",
            columnsPanelTextFieldPlaceholder: "Columnas",
            columnsPanelDragIconLabel: "Reordenar Columnas",
            columnsPanelShowAllButton: "Mostrar Todas",
            columnsPanelHideAllButton: "Ocultar Todas",
            // Filter panel text
            filterPanelAddFilter: "Agregar Filtros",
            filterPanelDeleteIconLabel: "Eliminar",
            filterPanelOperators: "Operador",
            filterPanelOperatorAnd: "Y",
            filterPanelOperatorOr: "O",
            filterPanelColumns: "Columnas",
            filterPanelInputLabel: "Valor",
            filterPanelInputPlaceholder: "Filtrar por valor",
            // Filter operators text
            filterOperatorContains: "Contiene",
            filterOperatorEquals: "Igual",
            filterOperatorStartsWith: "Empieza con",
            filterOperatorEndsWith: "Termina con",
            filterOperatorIs: "es",
            filterOperatorNot: "no es",
            filterOperatorOnOrAfter: "después",
            filterOperatorBefore: "antes",
            filterOperatorOnOrBefore: "antes",
            // Column menu text
            columnMenuLabel: "Menú",
            columnMenuShowColumns: "Mostrar",
            columnMenuFilter: "Filtros",
            columnMenuHideColumn: "Ocultar",
            columnMenuUnsort: "Deshacer",
            columnMenuSortAsc: "Ordenar Asc",
            columnMenuSortDesc: "Ordenar Desc",
            // Column header text
            columnHeaderFiltersTooltipActive: (count) =>
              `${count} filtros activos`,
            columnHeaderFiltersLabel: "Filtros",
            columnHeaderSortIconLabel: "Ordenar",
            // Rows selected footer text
            footerRowSelected: (count) =>
              count !== 1
                ? `${count.toLocaleString()} fila/s seleccionada/s`
                : `${count.toLocaleString()} fila/s seleccionada/s`,
            // Total rows footer text
            footerTotalRows: "Total Registros:",
            // Pagination footer text
            footerPaginationRowsPerPage: "Registros por página:",
          }}
        />
      </div>
    </React.Fragment>
  );
};
